import { render, staticRenderFns } from "./TradeHash.pc.vue?vue&type=template&id=0385e0f4&scoped=true&"
import script from "./TradeHash.pc.vue?vue&type=script&lang=js&"
export * from "./TradeHash.pc.vue?vue&type=script&lang=js&"
import style0 from "./TradeHash.pc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TradeHash.pc.vue?vue&type=style&index=1&id=0385e0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385e0f4",
  null
  
)

export default component.exports